import React, { FC, useEffect, useState } from "react"
import _ from 'lodash'
import { RouteComponentProps, navigate } from "@reach/router"
// Components
import { TabView, TabPanel } from 'primereact/tabview';
import DefaultsRentRoll from "components/property/defaults/defaults-rent-roll"
import PropertyDefaultsMultifamily from "components/property/defaults/defaults-multifamily"
import DefaultsMarketLease from "components/property/defaults/defaults-market-lease";
import DefaultsNamedItem from "components/property/defaults/defaults-named-item"
// Data
import api_match from "data/interface/api"
import { local } from "data/lib/local-json"
import marketLeaseService from 'data/market-lease'
import increaseService from 'data/increase'
import payoutService from 'data/payout'
import inflationService from 'data/inflation'
import propertyService from "data/property"
import { updateValidation } from "components/table/table-automation"
// Styles
import { Tabs_s } from 'styles/tab-styles'
import { DefaultsCommercial_s, DefaultsMultifamily_s } from 'components/property/defaults/defaults-styles'

const Defaults: FC<RouteComponentProps> = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const propertyType = local('property_type')
  const [property, setProperty] = useState<object>({})
  const [increaseData, setIncreaseData] = useState<object[]>([])
  const [inflationData, setInflationData] = useState<object[]>([])
  const [marketLeaseData, setMarketLeaseData] = useState<object[]>([])
  const [payoutData, setPayoutData] = useState<object[]>([])

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe(data => {
      if (data.value.length > 0){
        let current = propertyService.get();
        if(local("property_type") === "Hospitality") navigate("/n/property/settings")
        else setProperty(current);
      }
    })

    const increaseSubscription = increaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setIncreaseData(init.value),
        ok    => {
          setIncreaseData(ok.value)
        },
        err   => {
          setIncreaseData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const inflationSubscription = inflationService.stream().subscribe(data => {
      api_match(
        data,
        init  => setInflationData(init.value),
        ok    => {
          setInflationData(ok.value)
        },
        err   => {
          setInflationData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const marketLeaseSubscription = marketLeaseService.stream().subscribe(data => {
      api_match(
        data,
        init  => setMarketLeaseData(init.value),
        ok    => {
          setMarketLeaseData(ok.value)
        },
        err   => {
          setMarketLeaseData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    const payoutSubscription = payoutService.stream().subscribe(data => {
      api_match(
        data,
        init  => setPayoutData(init.value),
        ok    => {
          setPayoutData(ok.value)
        },
        err   => {
          setPayoutData(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    increaseService.fetchIncrease(local('property'))
    inflationService.fetchInflation(local('property'))
    marketLeaseService.fetchMarketLeases(local('property'))
    payoutService.fetchPayout(local('property'))

    return function cleanup() {
      increaseSubscription.unsubscribe();
      inflationSubscription.unsubscribe();
      marketLeaseSubscription.unsubscribe();
      payoutSubscription.unsubscribe();
      propertySubscription.unsubscribe();
    }

  }, [])

  useEffect(() => {
    updateValidation()
  },[property])

  return propertyType !== 'Multifamily' ?
    <DefaultsCommercial_s><Tabs_s>
      <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
        <TabPanel header="Rent Roll">
          <DefaultsRentRoll
            increaseData={increaseData}
            inflationData={inflationData}
            marketLeaseData={marketLeaseData}
            payoutData={payoutData}
            property={property}
          />
        </TabPanel>
        <TabPanel header="Market Lease">
          <DefaultsMarketLease
            increaseData={increaseData}
            inflationData={inflationData}
            marketLeaseData={marketLeaseData}
            payoutData={payoutData}
            property={property}
          />
        </TabPanel>
        <TabPanel header="Named Item">
          <DefaultsNamedItem
            inflationData={inflationData}
            payoutData={payoutData}
            property={property}
          />
        </TabPanel>
        <TabPanel header="Multifamily" disabled={propertyType !== 'Mixed-Use'}>
          <PropertyDefaultsMultifamily />
        </TabPanel>
      </TabView>
    </Tabs_s>
  </DefaultsCommercial_s> : <DefaultsMultifamily_s><PropertyDefaultsMultifamily /></DefaultsMultifamily_s>
}

export default Defaults
